import { Grid } from '@mui/material';
import { useFormWithStateContext } from 'contexts/FormWithStateContext';
import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Column } from 'further-ui/components/Layout';
import {
  CapitalActionFormState,
  UpdateCapitalActionFormValues,
} from '../../../hooks/useCapitalActionForm';
import AdvanceSubscriptionAllocations from './AdvanceSubscriptionAllocations';

type Props = {
  index: number;
  vehicleId: string;
  entryType: CapitalActionEntryType;
  baseCurrency: CurrencyCode;
};

const AdvanceSubscriptionPaymentDetails: React.FC<Props> = ({
  index,
  vehicleId,
  baseCurrency,
}) => {
  const {
    formMethods: { watch, setValue },
  } = useFormWithStateContext<
    UpdateCapitalActionFormValues,
    CapitalActionFormState
  >();

  const capitalBreakdown = watch(`entries.${index}.capitalBreakdown`);

  const handleAllocationsChange = (
    allocations: Array<{
      commitmentId: string;
      amountLcy: number;
      fundsCalled?: {
        fromCommitmentLcy: number;
        fromRecallableDistributionLcy: number;
      };
    }>,
  ) => {
    const totalAmount = allocations.reduce(
      (sum, allocation) => sum + allocation.amountLcy,
      0,
    );

    setValue(`entries.${index}.totalAmountLcy`, totalAmount);
    setValue(
      `entries.${index}.capitalBreakdown`,
      allocations.map((allocation) => ({
        commitmentId: allocation.commitmentId,
        amountLcy: allocation.amountLcy,
        fundsCalled: {
          fromCommitmentLcy: allocation.fundsCalled?.fromCommitmentLcy ?? 0,
          fromRecallableDistributionLcy:
            allocation.fundsCalled?.fromRecallableDistributionLcy ?? 0,
        },
      })),
    );
  };

  return (
    <>
      <Grid container>
        <Grid size={{ sm: 12, md: 12, lg: 8 }}>
          <Column spacing="md"></Column>
        </Grid>
      </Grid>

      <AdvanceSubscriptionAllocations
        vehicleId={vehicleId}
        currency={baseCurrency}
        capitalBreakdown={capitalBreakdown ?? []}
        onChange={handleAllocationsChange}
      />
    </>
  );
};

export default AdvanceSubscriptionPaymentDetails;
